import { Feature, FeaturesData } from './types';

export const getFeaturesDataFromList = (
  featureList: Feature[] | undefined
): FeaturesData | null => {
  const data: FeaturesData = {};

  if (!featureList?.length) return null;

  featureList.forEach(({ name, ...feature }) => {
    data[name] = { ...feature };
  });

  return data;
};
